import { AxiosError } from 'axios'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { TMarketServiceError, TMarketCategoriesResponse } from 'services/MarketService'
import { QueryCacheKeys } from 'enums'
import * as userSelectors from 'containers/User/user-selectors'
import { MarketService } from 'services'
import { getRequestError } from 'utils/helpers'

export type TFetchFnError = AxiosError<TMarketServiceError>
export type TError = [string, TFetchFnError]
export type TQueryKey = string[]
export type TQueryFnOpts = UseQueryOptions<TMarketCategoriesResponse, TError, TMarketCategoriesResponse, TQueryKey>

const key = QueryCacheKeys.marketCategories

/**
 * Хук API получение списка категорий маркетплейса
 */
export default function useFetchMarkerCategories(opts: TQueryFnOpts = {}) {
    const { t } = useTranslation()
    const user = useSelector(userSelectors.user)

    return useQuery([`${key}-${user.id}`], () => {
        return MarketService.fetchMarketCategories()
            .then(({ data }) => {
                return data
            })
            .catch((err) => {
                return Promise.reject([getRequestError(err) || t('update_error'), err])
            })
    }, opts)
}
